import { Flex, Icon } from "@chakra-ui/react";
import { useColorModeValue } from "../../common/components/chakra/color-mode.tsx";
import { Button } from "../../common/components/Button.tsx";
import { FiMenu, FiShare } from "react-icons/fi";
import Logo from "../Logo.tsx";

interface MobileProps {
  onOpen: () => void;
  // Allow passing any Flex props if needed without over-typing
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

const MobileNav = ({ onOpen, ...rest }: MobileProps) => {
  return (
    <Flex
      style={{ position: "sticky", top: 0, zIndex: 500 }}
      height="20"
      alignItems="center"
      bg={useColorModeValue("white", "gray.900")}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue("gray.200", "gray.700")}
      justifyContent="flex-start"
      {...rest}
    >
      <Flex style={{ flex: 1 }} ml={2} justifyContent={"center"}>
        <Button variant="outline" onClick={onOpen} aria-label="open menu">
          <Icon as={FiMenu} />
        </Button>
      </Flex>
      <Flex
        style={{ flex: 8 }}
        h={"inherit"}
        w={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Logo style={{ height: "65%" }} />
      </Flex>
      <div style={{ flex: 1 }}>
        <Button
          onClick={() => {
            window.navigator.share?.({ url: window.location.pathname });
          }}
          size="md"
          variant={"ghost"}
        >
          <Icon as={FiShare} />
        </Button>
      </div>
    </Flex>
  );
};

export default MobileNav;
